exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".audit-result-modal-body{background:#f1f1f1;font-size:1.4rem;margin:20px}.audit-result-modal-body .description{margin-bottom:10px}.audit-result-modal-body .ok-button{display:-ms-flexbox;display:flex;-ms-flex-pack:end;justify-content:flex-end}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/reports/audit-summary/components/audit-result-modal/index.scss
// module id = 5175
// module chunks = 0